import type {
  HandleClickOfficialMarketBanner,
  ProfileInfoProps,
} from './types';
import { ProfileAvatar } from './components/ProfileAvatar';
import {
  Carousel,
  Flex,
  IconInfo,
  Typography,
  useScreenSize,
  type SliderRef,
} from '@banhala/ui-kit';
import { MainName } from './components/MainName';
import {
  bridge,
  useNavigator,
} from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks';
import type { AnyObject } from '../../../../types';
import { Banner } from './components/Banner';
import { useRef } from 'react';
import { Tooltip } from '../../../Tooltip';

export const ProfileInfo = ({ entity }: ProfileInfoProps) => {
  const { navigator } = useNavigator();
  const { openDeeplink } = useOpenDeeplink();
  const { width } = useScreenSize();
  const profile = entity?.[0];
  const officialMarketBanner = (() => {
    if (!profile || !profile.item.official_markets) {
      return [];
    }
    return profile.item.official_markets;
  })();
  const scrollRef = useRef<SliderRef | null>(null);
  const handleClickOfficialMarketBanner: HandleClickOfficialMarketBanner =
    async (item, logging) => {
      logClickOfficialMarketBanner({ logging });
      const { deeplink } = item;
      if (deeplink.includes('ably://markets')) {
        const sno = parseInt(
          deeplink.replace('ably://markets/', '').split('/')[0],
          10,
        );
        navigator.moveToMarketHome({
          sno,
        });
      } else {
        openDeeplink(deeplink);
      }
    };
  if (!profile) {
    return null;
  }

  return (
    <>
      <Flex.Row
        padding={{ horizontal: 16, vertical: 16 }}
        gap={16}
        alignItems="center"
      >
        <ProfileAvatar image={profile.item.image} />
        <Flex.Column alignItems="flex-start" flexGrow={1} gap={8}>
          <Flex.Column gap={2}>
            <MainName text={`${profile.item.main_name} 모아보기`} testID={'브랜드홈'} />
            <Flex.Row alignItems="center">
              <Typography
                color="content_tertiary"
                ellipsizeMode="tail"
                type="subtitle5"
              >
                {profile.item.sub_name}
              </Typography>
              <Typography
                color="content_tertiary"
                ellipsizeMode="tail"
                type="body5"
              >
                &nbsp;·&nbsp;{profile.item.badge.text}
              </Typography>
            </Flex.Row>
          </Flex.Column>
        </Flex.Column>
        <Tooltip
          label={`${profile.item.main_name} 상품을 모아볼 수 있는 페이지에요`}
          tooltipStyle={{ marginLeft: 8 }}
        >
          <IconInfo width={16} height={16} />
        </Tooltip>
      </Flex.Row>
      {officialMarketBanner.length > 0 && (
        <Carousel
          sliderRef={scrollRef}
          data={officialMarketBanner}
          renderItem={({ item, index }) => (
            <Banner
              handleClickOfficialMarketBanner={handleClickOfficialMarketBanner}
              officialMarket={item}
              testID={`공식마켓바로가기버튼?LIST_INDEX=${index}`}
            />
          )}
          width={width}
          height={40}
        />
      )}
    </>
  );
};

const logClickOfficialMarketBanner = ({ logging }: { logging: AnyObject }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_OFFICIAL_MARKET',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
